let pathName = window.location.pathname
let hash = window.location.hash
let bbqFormPage = document.querySelector('#wpcf7-f803-o1');

if(pathName === "/letstalk/" && hash){
    document.querySelectorAll(".nearest-location select option")[15].selected = true;
}

if(pathName  === "/letstalk/"){
    let submit = document.querySelector('.wpcf7-submit')
    submit.addEventListener('wpcf7submit', (e)=>{
        console.log('convert')
        gtag_report_conversion('lets talk button')
    })
}

if (bbqFormPage) {
  let bbqSubmit = document.querySelector(".wpcf7-submit");
  bbqSubmit.addEventListener("wpcf7submit", (e) => {
    console.log("Vggiio 111");
    document.getElementById("bbq-form-row").style.display = "none";
  });
}